<template functional>
  <h3 :class="{ homme: props.profile.sex == 'MALE' }">{{ props.profile.pseudo }}<slot /></h3>
</template>

<script>
export default {
  props: ["profile"]
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

h3 {
  display: inline-block;
  font-weight: bold;
  margin: 0px;
  font-size: 16px;
  color: $theme_color;
  word-break: break-all;
  &.homme {
    color: #0e66cc !important;
  }
}
</style>
